$( document ).ready(function() {
    $(".top-nav__item--sub").click(function(e){
        $(this).toggleClass('top-nav__item--sub-active');
        var panel = $(this).find(".top-nav__dropdown");
        panel.toggleClass('top-nav__dropdown--active');

    });
    mobileMenu();

    $('.phoneNumber').inputmask({
        mask:["+7 (X99) 999-9999"],
        definitions: { "X": { validator: "[0-69]" } },


    });
    ($('.phoneNumber')).on('input',function (e){
        $('.phone_length').val($(this).inputmask('unmaskedvalue'))
    })
    $('.phone__num').click(function(){
        yametrikaGoals('zvonok');
        googleAnalitics('zvonok');
    });
    $('.contact_form').on('submit', function (e) {

        e.preventDefault(); // отменяем поведение по умолчанию
        var data = $(this).serialize(); // получаем все данные формы
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type     : "POST",
            url      : $(this).attr('action'),
            data     : data,
            success:function(data) {
                if (data.success) {
                    // notice that we are expecting a json array with success = true and a payload
                    $('.contact_form_modal').modal('hide');
                    $("input, select, textarea").removeClass('is-invalid');
                    $("input, select, textarea").addClass('is-valid');
                    $('.invalid-feedback').html('');
                    resetForm($(this));
                    window.location = '/thanks-page';
                    $.notify({
                        message: "Спасибо за заявку. Мы с вами свяжемся!"
                    },{
                        timer: 2000,
                        type: "success",
                    });
                    yametrikaGoals('zayavka');
                    googleAnalitics('zayavka');
                    window.location.href = '/thanks-page';
                } else {
                    // for debugging
                    console.log(data.errors);
                    $("input, select, textarea").removeClass('is-invalid');
                    $("input, select, textarea").addClass('is-valid');
                    $('.invalid-feedback').html('');
                    printErrorMsg(data.errors);
                }
            }
        });
    });
    $('.expert_form').on('submit', function (e) {
        e.preventDefault(); // отменяем поведение по умолчанию
        var data = new FormData($(this)[0]); // получаем все данные формы
        var file_data = $('#upload').prop('files')[0];
        data.append('file', file_data);
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type     : "POST",
            url      : $(this).attr('action'),
            data     : data,
            processData: false,
            contentType: false,
            dataType: "json",
            success:function(data) {
                if (data.success) {
                    // notice that we are expecting a json array with success = true and a payload

                    $('.contact_form_modal').modal('hide');

                    $("input, select, textarea").removeClass('is-invalid');
                    $("input, select, textarea").addClass('is-valid');
                    $('.invalid-feedback').html('');
                    resetForm($(this));

                    $.notify({

                        message: "Спасибо за заявку. Мы с вами свяжемся!"
                    },{
                        timer: 2000,
                        type: "success",
                    });
                    console.log('zayavka');
                    ym(74556517,'reachGoal','zayavka');

                } else {
                    // for debugging
                    console.log(data.errors);
                    $("input, select, textarea").removeClass('is-invalid');
                    $("input, select, textarea").addClass('is-valid');
                    $('.invalid-feedback').html('');
                    printErrorMsg(data.errors);
                }
            }
        });
    });
});
function mobileMenu() {
    var toggle =  $('.mobile-nav-panel__icon');
    var icon = $('.mobile-nav-panel__line');
    toggle.on('click', function() {
        icon.toggleClass("mobile-nav-panel__line--on");

    });

    var btn = $('#scroll-top');

    $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
            btn.addClass('scroll-top-btn--show');
        } else {
            btn.removeClass('scroll-top-btn--show');
        }
    });

    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
    });

}
$('.contact_form_modal').on('hide.bs.modal', function (event){
    resetForm($(this));
});
function printErrorMsg (msg) {
    $.each( msg, function( key, value ) {
        input = $(".contact_form").find("[name='"+key+"']");
        input.removeClass('is-valid');
        input.addClass('is-invalid');
        input.next('.invalid-feedback').html(value);
        if(key === "phone_length") {
            $('input[name="phone"]').addClass('is-invalid')
            if($('input[name="phone"]').next('.invalid-feedback').html() === "") {
                $('input[name="phone"]').next('.invalid-feedback').html("Введите номер телефона полностью")
            }

        }
        input = $(".expert_form").find("[name='"+key+"']");
        input.removeClass('is-valid');
        input.addClass('is-invalid');
        input.next('.invalid-feedback').html(value);
        if(key === 'conf_agree') {
            $('.invalid-feedback--conf_agree').html(value)
        }
    });
}
function resetForm(el) {
    el.find('input, select, textarea').val('');
    $("input, select, textarea").removeClass('is-invalid');
    $("input, select, textarea").removeClass('is-valid');
}
function yametrikaGoals(Goal) {
    window.onload = function() {
        yaCounter53590390.reachGoal(Goal); return true;
    }
}
function yametrikaGoals2(Goal) {
    window.onload = function() {
        yaCounter74556517.reachGoal(Goal); return true;
    }
}
function googleAnalitics(label) {
    gtag('event', label, {
        'event_label': label,
    });
}

